import { useQuery } from "react-query";
import axiosBaseConfig from "../../../configs/axios/axios-base.config";
import allEnvs from "../../../configs/env.config";
import { store } from "../../../redux/store";

export const useGetInit = () => {
	const userId = store.getState()?.currentUser?.id ?? null;

	return useQuery(
		["init"],
		() => {
			return axiosBaseConfig
				.put("shared/init", {
					AppVersion: allEnvs.version,
					OS: "pwa",
					UserId: userId,
				})
				.then((res) => res.data);
		},
		{
			refetchOnWindowFocus: false,
			staleTime: Infinity,
		}
	);
};
